export default __webpack_public_path__ + "static/media/has_problem.a4baec3d.svg";